<!--
    ====================================================================
      FLOATING CHATBOT  +  3 WEBSITE CONTEXT VARIABLES
    ====================================================================
      This is your original working floating chatbot, with TWO additions:

      EDIT 1: Auto-capture 3 values from the webpage (no user prompt):
              webpage_id, user_name, webpage_version
      EDIT 2: Send those 3 values to your Copilot Studio agent over
              Direct Line, attached to the startConversation event.

      Everything else (connection, reset, greeting, citation stripping,
      unread dot, inactivity) is unchanged from your working file.
      The two new sections are labeled  [ CONTEXT EDIT 1 ]  and
      [ CONTEXT EDIT 2 ]  so they are easy to find.
    ====================================================================
-->

<!-- ##################################################################
     SECTION 1: CSS
################################################################## -->
<style>
  /* The round floating launcher button. */
  #cs-launcher {
    position: fixed; bottom: 24px; right: 24px; width: 64px; height: 64px;
    border-radius: 50%; background: #0078D4; color: #fff; border: none;
    cursor: pointer; box-shadow: 0 4px 16px rgba(0,0,0,0.2); display: flex;
    align-items: center; justify-content: center; z-index: 9999;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  #cs-launcher:hover { transform: scale(1.08); box-shadow: 0 6px 20px rgba(0,0,0,0.28); }
  #cs-launcher svg { width: 30px; height: 30px; fill: #fff; }

  /* The red "unread message" dot on the launcher (hidden by default). */
  #cs-launcher .cs-dot {
    position: absolute; top: 8px; right: 8px; width: 12px; height: 12px;
    background: #E81123; border: 2px solid #fff; border-radius: 50%; display: none;
  }
  #cs-launcher.cs-has-unread .cs-dot { display: block; }

  /* The popup chat card (hidden until JS adds cs-open). */
  #cs-chat-window {
    position: fixed; bottom: 100px; right: 24px; width: 400px; height: 50vh;
    min-height: 400px; max-height: 700px; background: #fff; border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.25); visibility:hidden; flex-direction: column;
    overflow: hidden; z-index: 9999; transform: translateY(20px); opacity: 0;
    transition: transform 0.25s ease, opacity 0.25s ease;
    flex: 1 1 auto;min-height: 0;
  }
  #cs-chat-window.cs-open { display: flex; transform: translateY(0); opacity: 1; overflow: auto; visibility: visible;min-height: 0; }

  /* The blue header bar. */
  #cs-chat-header {
    background: #0078D4; color: #fff; padding: 14px 16px; display: flex;
    align-items: center; justify-content: space-between;
    font-family: 'Segoe UI', Arial, sans-serif; font-size: 16px; font-weight: 600;
  }
  .cs-header-actions { display: flex; align-items: center; gap: 6px; }

  /* The "start new chat" button. */
  #cs-chat-restart {
    background: transparent; border: none; color: #fff; cursor: pointer;
    display: flex; align-items: center; justify-content: center; padding: 4px; border-radius: 4px;
  }
  #cs-chat-restart svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  #cs-chat-restart:hover { background: rgba(255,255,255,0.15); }

  /* The small close (x) button. */
  #cs-chat-close {
    background: transparent; border: none; color: #fff; font-size: 22px;
    cursor: pointer; line-height: 1; padding: 0 4px;
  }
  #cs-chat-close:hover { opacity: 0.8; }

  /* The empty box the chatbot gets drawn into. */
  /* #webchat { flex: 1; min-height: 0; background: #fff; } */
 #webchat {
  flex: 1 1 auto;
  min-height: 300px;
  display: flex;
  flex-direction: column;
}

  /* Mobile responsive. */
  @media (max-width: 600px) {
    #cs-chat-window { width: calc(100vw - 24px); right: 12px; bottom: 90px; height: 70vh; }
    #cs-launcher { bottom: 16px; right: 16px; }
  }
</style>
<!-- END SECTION 1 (CSS) -->

<!-- ##################################################################
     SECTION 2: Data
################################################################## -->
<div id="div-perf-data" [attr.data-perf-data-json]="PerfDataJson"></div>

<!-- ##################################################################
     SECTION 3: HTML  (structure of the widget)
################################################################## -->

<!-- The round floating button. -->
<button id="cs-launcher" aria-label="Open chat" (click)="launchWebChat()" style="background-color:transparent;">
  <img alt="Silhouette of a person's head" src="/assets/icon/AIChatLaunchLogo.svg" />
  <span class="cs-dot"></span>
</button>
<!-- <button id="cs-launcher" aria-label="Open chat" (click)="launchWebChat()">
  <svg viewBox="0 0 24 24">
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
  </svg>
  <span class="cs-dot"></span>
</button> -->

<!-- The popup chat card. -->
<div id="cs-chat-window" role="dialog" aria-label="Chat window">
  <div id="cs-chat-header">
    <span>Ask Chat</span>
    <div class="cs-header-actions">
      <button id="cs-chat-restart" aria-label="Start new chat" title="Start new chat">
        <svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5"/></svg>
      </button>
      <button id="cs-chat-close" aria-label="Close chat">×</button>
    </div>
  </div>
  <!-- The chatbot gets injected into this empty div. -->
  <!-- <div id="webchat" role="main" [attr.data-contact-rsm-email]="contactRSMEmail" [attr.data-contact-rsm-name]="contactRSMName"></div> -->
  <!-- moving to index.html-->
   <div id="webchat" role="dialog"></div>
</div>
<!-- END SECTION 3 (HTML) -->


